export default {
  title: "Person numbers",

  input: {
    title: "Edit person number",
    socialSecurityNumber: {
      label: "SSN",
      notFound: "No social security number available",
    },
  },
}
